<template>
  <v-container fluid fill-width class="ma-0 pa-0 ml-2 mt-2">
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-0 ma-0">
        <v-container
          fluid
          fill-width
          class="ma-0 pa-2 pl-5 pt-5"
          style="background-color: white;"
        >
          <v-row
            v-for="(dp, dip) in domainPairs"
            :key="'dr-' + dip"
            class="pa-0 ma-0 py-2"
            align="start"
            justify="center"
          >
            <v-col cols="6" class="pa-0 ma-0" align="start" justify="center">
              <img
                :src="'/images/' + dp[0] + '-icon-128.png'"
                :title="dp[0]"
                style="height:2.5em"
                align="center"
                @error="missingDomainFallback"
              />
              <span class="pl-2" style="font-size: 1.3rem;">{{ dp[0] }}</span>
            </v-col>
            <v-col cols="6" class="pa-0 ma-0" align="start" justify="center">
              <img
                v-if="dp[1] != null"
                :src="'/images/' + dp[1] + '-icon-128.png'"
                :title="dp[1]"
                style="height:2.5em"
                align="center"
                @error="missingDomainFallback"
              />
              <span class="pl-2" style="font-size: 1.3rem;">{{ dp[1] }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { missingDomainFallback } from '@/utils/helpers';

export default {
  name: 'Domains',
  components: {},
  props: {},
  data() {
    return {
      domains: [
        'Autonomic',
        'Billing',
        'Cardiac',
        'Cognitive',
        'Dataset',
        'Demographics',
        'Disability',
        'Disease Features',
        'Exercise',
        'Falls',
        'Fatigue',
        'General Disease Severity',
        'General Health',
        'Genetic',
        'Hearing',
        'Laboratory',
        'Medical History',
        'Mental Health',
        'Motor',
        'Neuroimaging',
        'Nutrition',
        'Pain',
        'Physical Performance',
        'Prescription',
        'Quality of Life',
        'Rx',
        'Social Activities',
        'Social Isolation',
        'Sleep',
        'Stress',
        'Treatment',
        'Vestibular',
        'Vision',
        'Vitals',
        'Missing Domain',
      ],
      missingDomainFallback: missingDomainFallback,
    };
  },
  computed: {
    domainPairs() {
      let pairs = [];
      let offset = Math.ceil(this.domains.length / 2);
      let x = 0;
      for (x = 0; x < offset; ++x) {
        let d1 = this.domains[x];
        let d2 = this.domains[x + offset];
        pairs.push([d1, d2]);
      }
      return pairs;
    },
  },
  watch: {},
  async created() {},
  methods: {},
};
</script>

<style scoped></style>
